var AppEvent = {
	
	buildEventManager: function(object, name, fun) {
		return new (function(o, n, f) {
			this.o = o;
			this.n = n;
			this.f = f;

			this.remove = function() {
				$(this.o).off(this.n, this.f);
			}
		})(object, name, fun);
	},

	on: function(object, name, handler) {
		var evtfun = function (evt, params) {handler(params);};
		$(object).on(name, evtfun);
		return this.buildEventManager(object, name, evtfun);
	},

	off: function(object, name, handler) {
		if (handler != undefined) $(object).off(name, handler);
		else $(object).off(name);
	},

//	one: function(object, name, handler) {
//		$(object).one(name, function (evt, params) {handler(params);});
	one: function(object, name, handler, data) {
		var evtfun = function (evt, params) {handler(params);};
		$(object).one(name, data, evtfun);
		return this.buildEventManager(object, name, evtfun);
	},
	
	trigger: function(object, name, params) {
		$(object).trigger(name, params);
	}
	
}